import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { baseUrl } from "config/config";
import { getApiCall } from "services/apiHelper";


interface standardTenantState {
    data: standardTenantResponse;
    loading: boolean;
    error: string | null;
}

interface standardTenantResponse {
    message: string;
    result: standardTenantDetails[];
}

interface standardTenantDetails {
    standardTenant: string;
    naiCcode: string;
}

const initialState: standardTenantState = {
    data: {
        message: "",
        result: []
    },
    loading: false,
    error: null
};

export const getAllTenantData = createAsyncThunk("getAllTenantData", async (_, { rejectWithValue }) => {
    try {
        var url = `${baseUrl}StandardTenant/GetAll`;
        const response = await getApiCall<any>(url);
        return response;
    } catch (error: any) {
        console.error('Error in GET request:', error);
        return rejectWithValue(`${error.response.data.description} (${error.response.data.code})` || error.message);
    }
})

const allStandardTenatDataSlice = createSlice({
    name: 'invData',
    initialState,
    reducers: {
        resetState: (state) => {
            return initialState

        }
    },
    extraReducers: (builder) => {
        builder.addCase(getAllTenantData.pending, (state) => {
            state.loading = true;
        })
            .addCase(getAllTenantData.fulfilled, (state, action: PayloadAction<standardTenantResponse>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getAllTenantData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'something went wrong';
            })
    },
});

export const { resetState: resetAllStandardTenantData } = allStandardTenatDataSlice.actions;
export default allStandardTenatDataSlice.reducer;
